import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

/**
 * HeroSectionSlider
 *
 * Props:
 *   slides: Array<{ img: string, link?: string, alt?: string }>
 *
 * Example usage:
 *   import banner1 from "../assets/banner1.jpg";
 *   import banner2 from "../assets/banner2.jpg";
 *
 *   const slides = [
 *     { img: banner1, link: "/yatra",     alt: "Char Dham Yatra" },
 *     { img: banner2, link: "/gita-daan", alt: "Gita Jayanti"    },
 *   ];
 *
 *   <HeroSectionSlider slides={slides} />
 */
const HeroSectionImageSlider = ({ slides = [] }) => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);

  // Auto-slide functionality
  useEffect(() => {
    let interval;
    if (isAutoPlaying && slides.length > 1) {
      interval = setInterval(() => {
        setCurrentSlide((prev) => (prev + 1) % slides.length);
      }, 2000);
    }
    return () => clearInterval(interval);
  }, [isAutoPlaying, slides.length]);

  // Reset to first slide when slides prop changes
  useEffect(() => {
    setCurrentSlide(0);
    setIsAutoPlaying(true);
  }, [slides]);

  if (!slides.length) return null;

  return (
    <div className="relative w-full overflow-hidden bg-black md:mt-8">
      {/* Carousel Track */}
      <div className="relative w-full h-auto">
        {slides.map((slide, index) => (
          <div
            key={index}
            className="w-full bg-black"
            style={{
              position: index === currentSlide ? "relative" : "absolute",
              top: 0,
              left: 0,
              opacity: index === currentSlide ? 1 : 0,
              transition: "opacity 0.8s ease-in-out",
              zIndex: index === currentSlide ? 2 : 1,
            }}
          >
            {slide.link ? (
              <Link
                to={slide.link}
                className="block w-full h-full no-underline"
              >
                <img
                  loading="lazy"
                  decoding="async"
                  src={slide.img}
                  alt={slide.alt || `Slide ${index + 1}`}
                  className="w-full h-auto block object-contain"
                />
              </Link>
            ) : (
              <img
                loading="lazy"
                decoding="async"
                src={slide.img}
                alt={slide.alt || `Slide ${index + 1}`}
                className="w-full h-auto block object-contain"
              />
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default HeroSectionImageSlider;
